import type { GeneratedImageDescription } from '@/api/chatRelay';

export interface ChatRelayState {
  connectionId: string | undefined;
  descriptions: { [key: string]: GeneratedImageDescription | undefined };
}

export function getInitialChatRelayState(): ChatRelayState {
  return {
    connectionId: undefined,
    descriptions: {},
  };
}
